import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=b419a276&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=b419a276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b419a276",
  null
  
)

export default component.exports